import {
    AxiosHeaders,
    IRequestFetcherOptions,
} from "src/common/razzle-platform-components/types"
import axios from 'src/common/razzle-platform-components/axios'
import {BASE_API_URL, PUBLIC_USER_API_END_POINT} from 'src/common/razzle-platform-user/configs'


export const fetchUser = async (id: string, options: Pick<IRequestFetcherOptions, 'params'>, headers: AxiosHeaders={}) => {

    const params = options.params || {}

    const response = await axios.get(`${BASE_API_URL}${PUBLIC_USER_API_END_POINT}/${id}`, {params, headers})

    return { user: response.data }
}
